import JSRouter from "adminPage/JSRouter";
import FormValidator from "base/FormValidator";
import Message from "base/Message";
import ConfirmModal from "modal/ConfirmModal";
import Ajax from "base/Ajax";

JSRouter.register('adminUsers', /([0-9a-f]+)\/?/, (url_args) => {
    let $form = $(".js-admin-user-form");

    FormValidator.attach($form).on("submit", ($form) => {
        let $btn = $form.find("button[type='submit']");
        if ($btn.is(".admin-btn--loading")) return;
        $btn.addClass("admin-btn--loading");

        Ajax.post("adminUsers", (url_args[0] === "add" ? "" : url_args[0]), $form.serializeJSON()).then((user) => {
            if (url_args[0] === "add") {
                Message.schedule(new Message('User updated successfully', '', Message.SUCCESS));

                window.location.href = user.links.edit;
            } else {
                new Message('User updated successfully', '', Message.SUCCESS);

                $btn.removeClass("admin-btn--loading");
            }
        }).catch((e) => {
            $btn.removeClass("admin-btn--loading");
            new Message(e.message, "Couldn't update this user");
        })
    });

    $form.on("click", ".js-delete-user", function () {
        ConfirmModal.confirm('Are you sure want to remove this user?', undefined, {showLoading: true}).then((done) => {
            Ajax.delete("adminUsers", url_args[0]).then(() => {
                Message.schedule(new Message('User deleted successfully', '', Message.SUCCESS));

                window.location.href = window.CONFIG.urls.admin + 'adminUsers';
            }).catch((e) => {
                new Message(e.message, "Couldn't delete this user");
                done();
            })
        });

        return false;
    }).on("click", ".js-reset-password", function () {
        ConfirmModal.confirm("Are you sure want to reset this user's password? They will receive an email with instructions on how to proceed.", undefined, {showLoading: true}).then((done) => {
            Ajax.post("adminUsers", url_args[0] + "/resetPassword").then(() => {
                new Message("", "User password reset successfully", Message.SUCCESS);
                done();
            }).catch((e) => {
                new Message(e.message, "Couldn't reset the user's password");
                done();
            })
        });

        return false;
    });
});
